import React, { Component } from 'react';
import Checkbox from '../checkbox';
import InputNumber from '../input-number';
import { getColumnKey } from './util';
const sortInputStyle = {
    width: '60px',
};
const sortInputWrapStyle = {
    ...sortInputStyle,
    display: 'inline-block',
};
const sortInputWrapStyleCenter = {
    ...sortInputWrapStyle,
    textAlign: 'center',
};
class ColumnFilterMenuItem extends Component {
    constructor(props) {
        super(props);
        // 修改是否 lock (fixedLeft)
        this.handleFixedLeftChange = (e) => {
            const { customColumn } = this.state;
            const fixedLeft = e.target.checked ? 1 : 0;
            this.setState({
                customColumn: {
                    ...customColumn,
                    fixedLeft,
                    fixedRight: (fixedLeft === 1) ? 0 : customColumn.fixedRight,
                },
            });
        };
        // 修改是否隐藏
        this.handleHiddenChange = (e) => {
            const { customColumn } = this.state;
            const hidden = e.target.checked ? 0 : 1;
            this.setState({
                customColumn: {
                    ...customColumn,
                    hidden,
                },
            });
        };
        // 修改排序
        this.handleOrderSeqChange = (value) => {
            const { customColumn } = this.state;
            this.setState({
                customColumn: {
                    ...customColumn,
                    orderSeq: value,
                },
            });
        };
        // 获取校验的数据
        this.getValidateCustomColumn = () => {
            const { customColumn } = this.state;
            return Promise.resolve(customColumn);
        };
        const customColumn = props.customColumn || {
            hidden: 0,
            fixedLeft: 0,
            fixedRight: 0,
            orderSeq: props.index,
            fieldKey: getColumnKey(props.column, props.index),
        };
        this.state = {
            customColumn,
            prevCustomColumn: customColumn,
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { customColumn } = nextProps;
        const { prevCustomColumn } = prevState;
        if (customColumn && prevCustomColumn !== customColumn) {
            return {
                customColumn,
                prevCustomColumn: customColumn,
            };
        }
        return null;
    }
    render() {
        const { column, checkboxPrefixCls, inputNumberProps } = this.props;
        const { customColumn } = this.state;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: sortInputWrapStyleCenter },
                React.createElement(Checkbox, { prefixCls: checkboxPrefixCls, style: sortInputStyle, checked: customColumn.hidden !== 1, onChange: this.handleHiddenChange })),
            React.createElement("div", { className: "dropdown-menu-text" }, column.title),
            React.createElement("div", { style: sortInputWrapStyleCenter },
                React.createElement(Checkbox, { prefixCls: checkboxPrefixCls, name: "fixedLeft", checked: customColumn.fixedLeft === 1, onChange: this.handleFixedLeftChange })),
            React.createElement("div", { style: sortInputWrapStyle },
                React.createElement(InputNumber, Object.assign({}, inputNumberProps, { name: "orderSeq", style: sortInputStyle, min: 0, step: 1, precision: 0, value: customColumn.orderSeq, onChange: this.handleOrderSeqChange })))));
    }
}
export default ColumnFilterMenuItem;
